module.exports = __webpack_public_path__ + "static/media/june-img.ec8ddf02.jpg";